export default {
  async list(context, payload) {
    try {
      const response = await this.$api.call("role.list", payload);
      const responseData = response.data;

      if (payload.shouldMutateStore !== false) {
        context.commit("mutationRoles", responseData);
      }
      return response;
    } catch (error) {
      context.commit("mutationRoles", []);
      throw error;
    }
  },
  async detail(context, payload) {
    try {
      const response = await this.$api.call("role.detail", payload);
      const responseData = response.data;
      context.commit("mutationRole", responseData);
      return response;
    } catch (error) {
      context.commit("mutationRole", {});
      throw error;
    }
  },
  async create(context, payload) {
    try {
      const response = await this.$api.call("role.create", payload);
      const responseData = response.data;
      return responseData;
    } catch (error) {
      throw error;
    }
  },
  async edit(context, payload) {
    try {
      const response = await this.$api.call("role.edit", payload);
      const responseData = response.data;
      return responseData;
    } catch (error) {
      throw error;
    }
  },
  async delete(context, payload) {
    try {
      const response = await this.$api.call("role.delete", payload);
      const responseData = response.data;
      return responseData;
    } catch (error) {
      throw error;
    }
  },
  async addPermissions(context, payload) {
    try {
      const response = await this.$api.call("role.addPermissions", payload);
      const responseData = response.data;
      return responseData;
    } catch (error) {
      throw error;
    }
  },
  async deletePermissions(context, payload) {
    try {
      const response = await this.$api.call("role.deletePermissions", payload);
      const responseData = response.data;
      return responseData;
    } catch (error) {
      throw error;
    }
  },
  async deletePermission(context, payload) {
    try {
      const response = await this.$api.call("role.deletePermission", payload);
      const responseData = response.data;
      return responseData;
    } catch (error) {
      throw error;
    }
  },
  async editPermissions(context, payload) {
    try {
      const response = await this.$api.call("role.editPermissions", payload);
      const responseData = response.data;
      return responseData;
    } catch (error) {
      throw error;
    }
  },
  async resetList(context) {
    try {
      context.commit("mutationRoles", []);
      return [];
    } catch (error) {
      context.commit("mutationRoles", []);
      throw error;
    }
  },
};
